<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>押金退款管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="订单号" prop="orderNum">
            <el-input size="small" style="width: 200px;" v-model="formInline.orderNum" placeholder="订单号"></el-input>
          </el-form-item>

          <el-form-item label="所属展会" prop="exhibitionId">
            <el-select v-model="formInline.exhibitionId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in exhList"
                :key="item.id"
                :label="item.exhibitionName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属分类" prop="typeId">
            <el-select v-model="formInline.typeId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in typeSelect"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in statusSelect"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
<!--            <el-button @click="importExcel()"  size="small" type="primary">导出</el-button>-->
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="userId" label="用户ID" align="center">
          </el-table-column>
          <el-table-column prop="orderNum" label="订单号" align="center"></el-table-column>
          <el-table-column prop="linkman" label="联系人" align="center"></el-table-column>
          <el-table-column prop="linkPhone" label="联系电话" align="center"></el-table-column>
          <el-table-column prop="typeId" label="所属大类" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.typeId==1">服务类</el-tag>
              <el-tag type="danger" v-if="scope.row.typeId==2">工程类</el-tag>
              <el-tag type="info" v-if="scope.row.typeId==3">餐饮类</el-tag>
              <el-tag v-if="scope.row.typeId==4">租赁类</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="totalCashPledge" label="总押金" align="center"></el-table-column>
          <el-table-column prop="refCashPledge" label="可退押金" align="center"></el-table-column>
          <el-table-column prop="exhibitionName" label="展会名称" align="center"></el-table-column>
          <el-table-column prop="status" label="退单状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==1">待检验</el-tag>
              <el-tag  v-if="scope.row.status==2">待审核</el-tag>
              <el-tag  v-if="scope.row.status==3">退款中</el-tag>
              <el-tag v-if="scope.row.status==4">已拒绝</el-tag>
              <el-tag v-if="scope.row.status==5">已完成</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center"  prop="createTime" label="申请时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleInFo(scope.row)"style="width: 100px;margin: 1px;">订单详情</el-button>
              <el-button size="mini" type="warning" @click="upCash(scope.row.id,5)"style="width: 100px;margin: 1px;" v-if="scope.row.status === 2">同意</el-button>
              <el-button size="mini" type="warning" @click="upCash(scope.row.id,4)"style="width: 100px;margin: 1px;" v-if="scope.row.status === 2">拒绝</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>




      </el-main>
    </el-container>
  </div>
</template>

<script>


import {downloadRefundExcel, qryRefundList, upCashStatus} from '../../api/convenience'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import {addBanner, upBanner} from "../../api/rankingApi";


export default {
  name: "cashList",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        orderNum:'',
        exhibitionId:'',
        typeId:'',
        status:'',
        page:1,
        pageSize:10
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      exhList:[],
      typeSelect:[{"name":"服务类","value":"1"},
        {"name":"工程类","value":"2"},
        {"name":"餐饮类","value":"3"},
        {"name":"租赁类","value":"4"}],
      statusSelect:[{"name":"待检验","value":"1"},
        {"name":"待审核","value":"2"},
        {"name":"退款中","value":"3"},
        {"name":"已拒绝","value":"4"},
        {"name":"已完成","value":"5"}]

    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
      })

      qryRefundList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },


    //订单详情页面
    handleInFo(info) {
      if (info){
        this.$router.push({ path: '/convenience/refundDetail' ,query:{refundInfo:info}})
      }
    },

    upCash(id,status){
      this.$confirm('确定要'+(status==5?'退款':'驳回退款申请')+'吗?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        upCashStatus({id:id,status:status}).then(res =>{
          if(res.code==1){
            this.$message({
              type: 'success',
              message: '数据已更新!'
            })
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
          this.tableList();
        })
      }).catch(err => {
      })
    },

    importExcel(){
      downloadRefundExcel(this.formInline).then(res=>{
        let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        // type值看后台格式,有可能是application/x-xls或application/vnd.ms-excel
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = timestampToTime(new Date())+'押金退款列表.xls'
        link.click()
      });
    },


    resetFrom(){
      this.formInline.orderNum = '';
      this.formInline.exhibitionId = '';
      this.formInline.status = '';
      this.formInline.typeId = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },



  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/convenience/cashList.vue